import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="21"
		fill="none"
		viewBox="0 0 16 21"
		{...props}
	>
		<path
			stroke="var(--svg-color, currentColor)"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M5.763 4.353H3.527M7.998 13.294h-4.47M12.47 13.294h-1.677M12.47 16.088h-1.677M7.998 10.5h-4.47M12.47 10.5h-1.677M15.264 9.775A2.794 2.794 0 0 0 12.47 6.98H10.41a1.12 1.12 0 0 1-1.117-1.118V3.794A2.794 2.794 0 0 0 6.499 1H1.852A1.12 1.12 0 0 0 .734 2.118v16.764A1.117 1.117 0 0 0 1.852 20h12.294a1.12 1.12 0 0 0 1.118-1.118zM8.563 1.923l5.974 5.97"
		/>
	</svg>
);

export { SvgComponent as ManualIcon };
